import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceRespone } from 'src/app/model/serviceResponse';
import { AppConstants } from 'src/environments/constants';
import { CommonUtils } from 'src/utils/CommonUtils';
import { msConfig } from '../ms-config';
import { IIspezioniService } from './IIspezioniService';
import {  map } from 'rxjs/operators';
import { FaseStandard } from 'src/app/model/ordini/PosizioneFasi';
import { CreaIspezioneModel } from 'src/app/pages/ispezioni/model/CreaIspezioneModel';
import { rispondiIspezioni } from 'src/app/pages/ispezioni/model/rispondiIspezione';


@Injectable({
  providedIn: 'root'
})
export class IspezioniService implements  IIspezioniService {

  constructor(private http: HttpClient) {
    console.log('dentro isp service');
   }

  deleteIspezioneService( idIspezione: number): Observable<ServiceRespone> {
    //throw new Error('Method not implemented.');
    let url = msConfig['ms-collaudi'] + AppConstants.ISPEZIONI + "/" + idIspezione;
    let params: any = {};
    params.idIspezione = idIspezione
    return this.http
      .delete(url, params = {params})
      .pipe(map((resp: ServiceRespone) => {
        return resp;
      }))
  }

  getIspezioniService(isTeamView: boolean, first: number, length: number, dashboard : boolean,
     fornitore?: string, currentDate ?: Date, codiceOrdine?: string, codicePosizione?:string , faseStandard?: string, idIspettore?: number, ordinamentoPer?: string, direzione?:boolean, tipoIspezione?:string): Observable<ServiceRespone> {
    let url = msConfig['ms-collaudi'] + AppConstants.ISPEZIONI ;
    let params: any = {};
    params.isTeamView = isTeamView
    params.first = first
    params.length = length
    params=CommonUtils.containsParam(params,fornitore,"fornitore")
    params=CommonUtils.containsParam(params,idIspettore,"idIspettore")
    /*params=CommonUtils.containsParam(params,dataInizio,"dataInizio")
    params=CommonUtils.containsParam(params,dataFine,"dataFine")*/
    params=CommonUtils.containsParam(params,codiceOrdine,"codiceOrdine")
    params=CommonUtils.containsParam(params,codicePosizione,"codicePosizione")
    params=CommonUtils.containsParam(params,ordinamentoPer,"ordinamentoPer")
    params=CommonUtils.containsParam(params,direzione,"direzione")
    params=CommonUtils.containsParam(params,faseStandard,"filtroFaseStandard")
    params=CommonUtils.containsParam(params,dashboard,"dashboard")
    if(currentDate != null){
      params=CommonUtils.containsParam(params,CommonUtils.formatDate(currentDate),"dataInizio")
    }
    return this.http
      .get(url, { params })
      .pipe(map((resp: ServiceRespone) => {
        let ordine;
        ordine = resp;
        return ordine;
      }))
  }

  getTotaleIspezioniService(isTeamView: boolean,fornitore?: string,
    codiceOrdine?: string, currentDate ?: Date, codicePosizione?:string , faseStandard?: string, idIspettore?: number, ordinamentoPer?: string, direzione?:boolean,
    tipoIspezione?:string): Observable<ServiceRespone> {
    let url = msConfig['ms-collaudi'] + AppConstants.ISPEZIONI_COUNT ;
    let params: any = {};
    params.isTeamView = isTeamView
    /*params.first = first
    params.length = 2      */

    params=CommonUtils.containsParam(params,fornitore,"fornitore")
    params=CommonUtils.containsParam(params,idIspettore,"idIspettore")
    /*params=CommonUtils.containsParam(params,dataInizio,"dataInizio")
    params=CommonUtils.containsParam(params,dataFine,"dataFine")*/
    if(currentDate != null){
      params=CommonUtils.containsParam(params,CommonUtils.formatDate(currentDate),"dataInizio")
    }
    params=CommonUtils.containsParam(params,codiceOrdine,"codiceOrdine")
    params=CommonUtils.containsParam(params,codicePosizione,"codicePosizione")
    params=CommonUtils.containsParam(params,faseStandard,"filtroFaseStandard")
    params=CommonUtils.containsParam(params,ordinamentoPer,"ordinamentoPer")
    params=CommonUtils.containsParam(params,direzione,"direzione")
    params=CommonUtils.containsParam(params,tipoIspezione,"tipoIspezione")


    return this.http
      .get(url, { params })
      .pipe(map((resp: ServiceRespone) => {
        let ordine;
        ordine = resp;
        return ordine;
      }))
  }

  


  getDettaglioIspezioneService(isTeamView: boolean, idIspezione: number): Observable<ServiceRespone> {
    let url = msConfig['ms-collaudi'] +  AppConstants.ISPEZIONI + '/' + idIspezione;
    let params: any = {};
    params.isTeamView = isTeamView;

    return this.http
      .get(url, { params })
      .pipe(map((resp: ServiceRespone) => {
        let ordine;
        ordine = resp;
        return ordine;
      }))
  }

  convocaIspezione(data: CreaIspezioneModel): Observable<ServiceRespone> {
    let posizioni = [];
    posizioni = this.formatPosizioni(data); // dato da formattare per adattare l'oggetto al BE
    let params: any = {};
    let url = msConfig['ms-collaudi'] + AppConstants.ISPEZIONI;
    params = CommonUtils.containsParam(params, Object.keys(FaseStandard).find(key => FaseStandard[key] === data?.faseSelected), "faseStandard");
    params = CommonUtils.containsParam(params, CommonUtils.formatDate(data?.dataInizio), "dataInizio");
    params = CommonUtils.containsParam(params, CommonUtils.formatDate(data?.dataFine), "dataFine");
    params = CommonUtils.containsParam(params, data?.luogo, "luogo");
    params = CommonUtils.containsParam(params, data?.note, "note");
    return this.http
      .post(url, posizioni, { params })
      .pipe(map((resp: ServiceRespone) => {
        let response;
        response = resp;
        return response;
      }))
  }

  rispondiIspezione(data: rispondiIspezioni[]): Observable<ServiceRespone> {
    console.log(data)
    // dato da formattare per adattare l'oggetto al BE
    let url = msConfig['ms-collaudi'] + AppConstants.ISPEZIONI;

    let params: any = {};
    params = data
    let collaudi = [];
    data.forEach(element => {
      collaudi.push({
        idCollaudo: element.idCollaudo,
        isApprovato: element.isApprovato,
        // si formatta per evitare problemi dovuti al cambio d'ora solare-legale
        dataInizioProposta: element.dataInizioProposta != null ? CommonUtils.formatDate(element?.dataInizioProposta) : null,
        dataFineProposta: element.dataFineProposta != null ? CommonUtils.formatDate(element?.dataFineProposta) : null,
        note: element.note
      })
    })
    console.log(collaudi)

    return this.http
      .put(url, collaudi)
      .pipe(map((resp: ServiceRespone) => {
        let response;
        response = resp;
        return response;
      }))
  }

  formatPosizioni (data) {
    let posizioni = [];
    data?.positionsToSave?.forEach(element => {
      let posizione = { idPosizione: element.id, quantitaPosizione: element.quantitaTot, quantitaCollaudo: Number(element.quantitaInserita)};
        posizioni.push(posizione)
    });
    return posizioni;
  }


}
